export const HIERARCHY_SEARCH_LIMIT_ERROR =
  'Your search returned too many results. Try using more specific terms to narrow down the results.';
